/* global sampleYear */

export default function() {

  document.querySelector('select[data-paper-size]').addEventListener('change', function () { // don't use fat arrow here! need "this"
    const url = '/mapserver/include/' + this.value + '.html';
    this[0].selected = true;
    fetch(url)
    .then(response => response.text())
    .then(template => {
      loadPrintInfo(template);
    })
  });


  if (rwg.config.cpcPrintURL) {
    // 2023-10-14
    document.querySelector('button[rwg-tab=top-print').addEventListener('click', () => {
      fetch(rwg.config.cpcPrintURL)
      .then(response => response.text())
      .then(template => {
        loadPrintInfo(template);
        if (rwg.config.cpcPrintFunc) rwg.config.cpcPrintFunc();
      })
    })
  }

  // private function called after template is loaded
  function loadPrintInfo(template) {
    const activelayers = rwg.layers.getActiveDrawLayers()  // returns an array
    const urlBase = rwg.config.mapserv + '?map=' + rwg.config.mapfile + '&imagetype=png'  // png is just for legend, not the map

    document.querySelector('#print-options').style.display = 'none';
    document.querySelector('#print-container').style.display = '';
    const printContentDiv = document.querySelector('#print-content')
    // puts the blank template into the print-layout div (this is NOT a mapserv template)
    printContentDiv.innerHTML = template;

    rwg.map.setTarget('pmap');

    printContentDiv.querySelector('#printTitle').innerHTML = rwg.config.print.title;
    printContentDiv.querySelector('#printDisclaimer').innerHTML = rwg.config.print.disclaimer +
      '<br>printed ' + new Date().toLocaleDateString()
    if (printContentDiv.querySelector('#printNotes') && typeof sampleYear !== 'undefined') {
      printContentDiv.querySelector('#printNotes').value = sampleYear.get() + ' Soil Sampling';
    }

    /* *** Draw the legend *** */
    const urlLegend = urlBase + '&mode=legend&layers=' + activelayers.join('+');
    const plegendDiv = printContentDiv.querySelector('#plegend')
    // 2023-11-19 added plegendImg which allows setting img styles in the print templates but not using it anywhere yet
    const plegendImg = printContentDiv.querySelector('#plegend-img')
    if (plegendImg) {
      plegendImg.src = urlLegend
    } else if (plegendDiv) {
      plegendDiv.innerHTML = `<img src="${urlLegend}" style="max-width:2.0in">`
    }

    /*
    if (typeof rwgInitParams.layoutMapClick === 'function') { // in cpc conf.js
      pmap.on('click', rwgInitParams.layoutMapClick);
    }
    */
    /* // cpc nematode legend
    rwg.layers.getActiveDrawLayers().forEach(function(lyrName) {
      var olLayerName = rwg.layers.getLayerByName(lyrName).olLyr;
      var gwmap = map.getLayerByTitle(olLayerName).get('gwmap');
      if (gwmap && gwmap.thematicLegendText) {
        gwmap.thematicLegendText.forEach(function(txt, index) {
          document.getElementById('treatment-' + index).innerText = txt;
          // console.log(index, txt)
        });
        document.getElementById('printNotes').value = 'Treatment needs for ' +
          legend.getNodeById(lyrName).data + ' based on ' + sampleYear.get() + ' soil samples';
        // console.log(legend.getNodeById(lyrName).data);
      }
    });
    */
  }

}
